import React, { Component } from 'react';
import { Field } from 'formik';
import styled from 'styled-components';
import { Box } from '@rebass/grid';
import moment from 'moment-timezone';
import { DateInput } from '@blueprintjs/datetime';
// eslint-disable-next-line import/no-extraneous-dependencies
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';
import InlineMessage from '../../../InlineMessage';

export const FORMAT = 'YYYY-MM-DD hh:mm A';

type DateTimePickerProps = {
  name: any,
  label: any,
  disabled: any,
  form: any,
  incidentType: any,
  edit: any,
  maxDate: any,
  currentTime: any,
  timezone: any,
  minDate: any
};
class DateTimePicker extends Component<DateTimePickerProps> {
  render() {
    const {
      name,
      label,
      disabled,
      form,
      incidentType,
      edit,
      maxDate,
      currentTime,
      timezone,
      minDate
    } = this.props;
    const error = form.errors[name];
    // const time = form.values[name] ? form.values[name] : currentTime;
    const currentDateTime = moment
      .tz(form.values[name] ? form.values[name] : currentTime, timezone)
      .format(moment.HTML5_FMT.DATETIME_LOCAL);
    return (
      <DateTimeWrapper id={name} mx="1" mb="2" disabled={disabled}>
        <div className="fs-label">{label}</div>
        <DateInput
          id={name}
          value={disabled ? null : moment(currentDateTime)._d}
          closeOnSelection={false}
          parseDate={str => moment(str).format()}
          formatDate={date => moment(date).format(FORMAT)}
          maxDate={
            moment(
              moment
                .tz(maxDate, timezone)
                .format(moment.HTML5_FMT.DATETIME_LOCAL)
            )._d
          }
          minDate={
            moment(
              moment
                .tz(minDate, timezone)
                .format(moment.HTML5_FMT.DATETIME_LOCAL)
            )._d
          }
          placeholder="----/--/--, --:--:--"
          timePrecision="minutes"
          timePickerProps={{
            useAmPm: true
          }}
          large
          canClearSelection={false}
          onChange={value => {
            if (name === 'start' && incidentType === 'planned' && !edit) {
              const updatedEndTime = moment(value)
                .add(60, 'minutes')
                .format(FORMAT);
              form.setFieldValue(
                'end',
                moment(updatedEndTime).format(moment.HTML5_FMT.DATETIME_LOCAL)
              );
            }
            form.setFieldValue(
              name,
              moment(value).format(moment.HTML5_FMT.DATETIME_LOCAL)
            );
          }}
          disabled={disabled}
        />
        {error && form.submitCount > 0 && (
          <InlineMessage position="relative" level="error">
            {error}
          </InlineMessage>
        )}
      </DateTimeWrapper>
    );
  }
}

type FormikDateTimeProps = {
  name: any
};

const FormikDateTime = (props: FormikDateTimeProps) => (
  <Field name={props.name}>
    {({ form }) => <DateTimePicker form={form} {...props} />}
  </Field>
);

export default FormikDateTime;

const DateTimeWrapper = styled(Box)`
  width: 100%;
  .fs-label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    opacity: ${props => (props.disabled ? 0.5 : 1)};
  }
  span.bp3-popover-target {
    display: block;
  }
  .bp3-input-group .bp3-input {
    color: #183247;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    box-shadow: none;
    margin-bottom: 2px;
    border: 1px solid #cfd7df;
    border-radius: 4px;
    padding: 4px 12px 5px;
    resize: none;
    background-color: #fff;
    box-shadow: none;
    min-height: 32px;
    opacity: ${props => (props.disabled ? 0.5 : 1)};
  }
`;
